import Cookies from 'js-cookie'
import {
  toggleMsgBoxOpen,
} from '@/utils/message'
import { checkIsTokenValid } from '@/api/user'
import { LoginStatusEnum } from '@/store/modules/user'

/*
* Token 根据持久性分别存两份:
* 1. 不能持久化的: 内存中
* 2. 需要多Tab页共享且持久化的: Cookie/Storage
*
* 分两个地方存储是为了解决 多 Tab 页的一个问题:
* 打开 Tab-A -> 登录 -> 打开 Tab-B, 然后执行下面的任意一种操作
* - Tab-B 注销登录
* - Tab-B 注销登录, 又登录了自己的账户
* - Tab-B 注销登录, 又登录了其他的账户
*
* 回到 Tab-A, 不刷新页面的情况下(比如跳转路由或者调用接口),
* 希望能够检测到 token 有变化, 然后刷新页面
* */
const tokenKey = 'Authentication'
export const getTokenFromDisk = () => Cookies.get(tokenKey) ?? ''
export const setTokenInDisk = (token: string) => Cookies.set(tokenKey, token)
export const removeTokenInDisk = () => Cookies.remove(tokenKey)

let tokenInMemory = ''
export const getTokenFromMemory = () => tokenInMemory
export const setTokenInMemory = (token: string) => tokenInMemory = token
export const removeTokenInMemory = () => tokenInMemory = ''

export async function getLoginStatus (): Promise<LoginStatusEnum> {
  const tokenInDisk = getTokenFromDisk()
  const tokenInMemory = getTokenFromMemory()

  const hasTokenInDisk = tokenInDisk !== ''
  const hasTokenInMemory = tokenInMemory !== ''

  if (hasTokenInDisk) {
    if (hasTokenInMemory) {
      if (tokenInDisk === tokenInMemory) {
        return LoginStatusEnum.Login
      } else {
        return LoginStatusEnum.OtherUserHasLoginFromOtherTab
      }
    } else {
      toggleMsgBoxOpen(true)
      let isTokenValid: boolean
      try {
        isTokenValid = await checkIsTokenValid(tokenInDisk)
      } catch (e) {
        isTokenValid = false
      } finally {
        toggleMsgBoxOpen(false)
      }

      if (isTokenValid) {
        setTokenInMemory(tokenInDisk) // 建议设置, 否则在路由钩子中会重复走该逻辑, 重复发请求. 虽然它会使函数有副作用
        // TODO: 利用发布/订阅添加 AfterLogin 钩子
        return LoginStatusEnum.Login
      } else {
        removeTokenInDisk() // 建议清空, 否则会通过路由守卫钩子进入页面, 只有在发请求才能感知到 token 无效. 这样就没有及时告知用户 token 无效要重新登录
        return LoginStatusEnum.TokenInvalid
      }
    }
  } else {
    if (hasTokenInMemory) {
      return LoginStatusEnum.LogoutFromOtherTab
    } else {
      return LoginStatusEnum.NeverLogin
    }
  }
}
